<template>
  <div class="checkbox-wrapper-20" :class="stylesInClass" :style="styles">
    <div class="switch">
      <input :id="`toggle-check-${idInput}`" class="input" type="checkbox" v-model="modelBinding"
        @change="onHandleChange" />
      <label :for="`toggle-check-${idInput}`" class="slider"></label>
    </div>
  </div>
</template>

<script>

export default {
  name: 'toggle-check-component',
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    model: {
      required: true
    },
    stylesInClass: {
      type: String,
      required: false
    },
    styles: {
      type: String,
      required: false
    },
    onChange: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      idInput: this.id,
      modelBinding: this.model,
    };
  },
  methods: {
    /**
     * Controlar cambios en el toggle.
     * 
     * @author Fernando Claros
     */
    onHandleChange(params) {
      this.onChange(this.modelBinding, params);
    }
  }
};
</script>